import styled, { keyframes } from 'styled-components';

export const fadeOutCss = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const animationLogo = keyframes`
  0% {
    max-width: 0;
  }
  50% {
    max-width: 100%;
  }
  100% {
    max-width: 0;
  }
`;

export const Inner = styled.div`
  position: relative;
  display: flex;
  width: 180px;
  height: 64px;
  user-select: none;

  svg {
    position: absolute;
    width: 180px;
    height: 64px;
  }

  #no-color-logo {
    z-index: 1;
  }

  #color-logo {
    z-index: 2;
  }
`;

export const WrapperIconLogo = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  animation-name: ${animationLogo};
  animation-duration: 7s;
  animation-iteration-count: infinite;
`;

export const Overlay = styled.div`
  z-index: 10002;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${(props) => props.theme.white};
  opacity: 1;
  will-change: opacity;
  overflow: hidden;

  &.fade-out {
    animation: ${fadeOutCss} 0.3s ease-in-out forwards;
  }
`;
